export const adminMenu = [{
  id: 'users',
  text: 'Administratorzy',
  route: 'admin.users.dashboard'
}, {
  id: 'templates',
  text: 'Szablony',
  route: 'admin.templates.dashboard'
}, {
  id: 'accounts',
  text: 'Konto do wysyłania',
  route: 'admin.accounts.dashboard'
}]

export const emailsMenu = [{
  id: 'emails',
  text: 'Adresy e-mail',
  route: 'admin.emails.dashboard'
}, {
  id: 'email-groups',
  text: 'Grupy',
  route: 'admin.email-groups.dashboard'
}]

export const newslettersMenu = [{
  id: 'messages',
  text: 'Wiadomości',
  route: 'admin.messages.dashboard'
}]

export const myMenu = [{
  id: 'my',
  text: 'Twój profil',
  route: 'admin.my'
}, {
  id: 'logout',
  text: 'Wyloguj się',
  route: 'logout'
}]



// WEBPACK FOOTER //
// ./src/components/admin/index.js